import { render } from "./CurrentlyCensor.vue?vue&type=template&id=aa63dd48"
import script from "./CurrentlyCensor.vue?vue&type=script&lang=js"
export * from "./CurrentlyCensor.vue?vue&type=script&lang=js"

import "./CurrentlyCensor.vue?vue&type=style&index=0&id=aa63dd48&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__